var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rectangle1",
    width: 669,
    height: 669,
    viewBox: "0 0 669 669",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 663,
    height: 663,
    rx: 331.5,
    fill: "#0085FF",
    fillOpacity: 0.2,
    stroke: "#0085FF",
    strokeWidth: 6,
    strokeDasharray: "0,0,0,2082.0341796875"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "20s",
    values: "0,0,0,2082.0341796875;            0,1041.01708984375,1041.01708984375,0;            2082.0341796875,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDot);
export default __webpack_public_path__ + "static/media/map-dot.3b44a10ce8f922f91f4a88ce348adfd2.svg";
export { ForwardRef as ReactComponent };